import { MyBooking } from '@common/interfaces/mybooking/mybooking.interface';

/**
 * MyBooking model details
 */
export interface MyBookingStateDetails {}

/**
 * MyBooking store state
 */
export interface MyBookingState extends MyBookingStateDetails {
  model: MyBooking | null;
}

/**
 * Name of the MyBooking Store
 */
export const MY_BOOKING_STORE_NAME = 'myBooking';

/**
 * MyBooking Store Interface
 */
export interface MyBookingStore {
  /** MyBooking state */
  [MY_BOOKING_STORE_NAME]: MyBookingState;
}
